/**
 * variant-megamenu-img
 * Swaps the featured image in the mega menu when hovering grandchild links
 * that have a data-image attribute set by header-mega-menu.liquid
 */
class VariantMegamenuImg extends HTMLElement {
  connectedCallback() {
    this.img = this.querySelector('img');
    if (!this.img) return;

    this.defaultSrc = this.img.src;
    this.defaultSrcset = this.img.srcset || '';

    // Find the parent mega-menu__content and listen on all [data-image] links inside it
    const content = this.closest('.mega-menu__content');
    if (!content) return;

    content.querySelectorAll('a[data-image]').forEach((link) => {
      link.addEventListener('mouseenter', () => {
        this.img.src = link.dataset.image;
        this.img.srcset = '';
      });
      link.addEventListener('mouseleave', () => {
        this.img.src = this.defaultSrc;
        this.img.srcset = this.defaultSrcset;
      });
    });
  }
}

if (!customElements.get('variant-megamenu-img')) {
  customElements.define('variant-megamenu-img', VariantMegamenuImg);
}
